<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>PVI Report Configurations</strong>
        </div>
        <b-row>
          <b-col class="col-lg-12 col-xl-9" v-if="initLoad">
            <div class="col-lg-7 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70);">
              <div style="text-align: right; margin-top: calc(50vh - 250px);">
                <img src="/web/img/mgauge_logo.png" alt="mGauge Logo" class="img-fluid">
                <h4 style="margin-right: 2rem !important;">State of the Art Analysis for Lenders.</h4>
              </div>
            </div>
          </b-col>
          <b-col class="col-lg-12 col-xl-9" v-else>
            <slot v-if="showReportTitle">
              {{activeReport.title}} - {{activeReport.id}}
            </slot>
            <div>
              <div class="row mt-4">
                <div class="col">
                  <b-card title="Card Title" no-body>
                    <b-tabs v-model="wizardStep" @activate-tab="wizardTabClick" card>
                      <b-tab title="1. Calculation Settings" active>
                        <button id="btnNextCalcSetts" class="btn btn-primary pull-right mr-2" @click="wizardNextStep(1, 'Step1')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                        <form class="validationForm" data-vv-scope="Step1" onsubmit="event.preventDefault(); return false;">
                          <b-row style="vertical-align: middle;padding-bottom:5px;" class="pt-2">
                            <b-col lg="4">
                              <div class="form-group row">
                                <label>Vehicle Set</label>
                                <dx-select-box id="selVehicleSet" style="width: 100%;" :items="vehicleSets" value-expr="id" display-expr="title"
                                               :value.sync="activeReport.vehicleSet"
                                               v-validate="{required: true}"
                                               name="Vehicle Set"
                                               :isValid="HasError('Step1.Vehicle Set')"
                                               :validationError="GetError('Step1.Vehicle Set')">
                                </dx-select-box>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row class="pt-4">
                            <b-col lg="4">
                              <label>Credit Score</label>
                              <b-form-group>
                                <b-form-checkbox-group v-model="activeReport.creditScores"
                                                       :checked="activeReport.creditScores"
                                                       :plain="false"
                                                       v-validate="{required: true}"
                                                       name="CreditScores"
                                                       :isValid="HasError('Step1.CreditScores')">
                                  <b-form-checkbox v-for="t in creditScores" :value="t" v-bind:key="t" :id="'cs'+t">
                                    {{ t.toString() }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-form-group>
                            </b-col>
                            <b-col lg="6">
                              <label>
                                Customer Cash
                                <slot v-if="activeReport.cashType !== 0"
                                      class="input-group-text ml-1 p-0">( % of MSRP )</slot>
                              </label>
                              <div class="input-group">
                                <!--<div class="input-group-prepend">
                                <b-form-select id="selCustCashType" v-model="activeReport.cashType" :options="[{text:'%', value:1}]">
                                </b-form-select>
                              </div>-->
                                <b-form-group>
                                  <b-form-checkbox-group v-model="activeReport.cashDowns"
                                                         :checked="activeReport.cashDowns"
                                                         :plain="false"
                                                         v-validate="{required: true}"
                                                         name="cashDowns"
                                                         :isValid="HasError('Step1.cashDowns')">
                                    <b-form-checkbox v-for="t in cashOptions" :value="t" v-bind:key="t" :id="'cd'+t">
                                      {{ t.toString() }}
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2 pt-4">
                            <b-col lg="4" v-if="activeReport.scanMode !== 1">
                              <label>Annual Mileage</label>
                              <b-form-checkbox-group v-model="activeReport.annualMileages"
                                                     :options="annualMileageOptions"
                                                     :plain="false"
                                                     v-validate="{required: true}"
                                                     name="Annual Mileage"
                                                     :isValid="HasError('Step1.Annual Mileage')">
                              </b-form-checkbox-group>
                              <!--<dx-select-box id="annualMileagedd" :items="annualMileageOptions" value-expr="value" display-expr="text" :value.sync="activeReport.annualMileage"
                                           v-validate="{required: true}"
                                           name="Annual Mileage"
                                           :wrapItemText="true"
                                           :accept-custom-value="true"
                                           @customItemCreating="customItemCreating($event)"
                                           :isValid="HasError('Step1.Annual Mileage')"
                                           :validationError="GetError('Step1.Annual Mileage')">
                            </dx-select-box>-->
                            </b-col>

                            <b-col lg="2">
                              <label>Scan Mode</label>
                              <dx-select-box id="scanModedd" :items="scanModeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanMode"
                                             v-validate="{required: true}"
                                             name="Scan Mode"
                                             :onValueChanged="ScanModeChange"
                                             :isValid="HasError('Step1.Scan Mode')"
                                             :validationError="GetError('Step1.Scan Mode')" />
                            </b-col>
                            <!--<b-col lg="2">
                              <label>Scan Type</label>
                              <dx-select-box id="scanTypedd" :items="scanTypeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanType"
                                             v-validate="{required: true}"
                                             name="Scan Type"
                                             :isValid="HasError('Step1.Scan Type')"
                                             :validationError="GetError('Step1.Scan Type')" />
                            </b-col>-->
                            <b-col lg="2" v-if="activeReport.scanType === 0">
                              <label>Adjustment Type</label>
                              <b-form-radio-group id="radGroupAdjustType" v-model="activeReport.adjustmentType" style="padding-top:6px;" :options="[
                                          {text: 'MSRP',value: 0},
                                          {text: 'Invoice',value: 1},
                                          ]">
                              </b-form-radio-group>
                            </b-col>
                            <b-col lg="2" v-if="activeReport.scanType === 0">
                              <label>Adjustment Value</label>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                                  </b-form-select>
                                </div>
                                <DxNumberBox id="inpAdjustValueSellPrice" class="form-control" v-model="activeReport.adjustmentValue"
                                             v-validate="{required: true, min_value: -999999, max_value:999999}"
                                             name="Adjustment Value" :show-spin-buttons="false"
                                             :isValid="HasError('Step1.Adjustment Value')"
                                             :validationError="GetError('Step1.Adjustment Value')"></DxNumberBox>
                              </div>
                            </b-col>
                          </b-row>
                        </form>
                        <div class="my-2">
                          <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step1')" v-bind:key="item.id">
                            {{ `#${item.id}: ${item.msg}`}}
                            <br />
                          </span>
                        </div>
                      </b-tab>
                      <b-tab title="2. Lender Options">
                        <b-row>
                          <b-col md="12" class="mb-4 p-0">
                            <button id="btnBack" class="btn btn-primary pull-left" @click="wizardBackStep()">
                              <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                            </button>
                            <button id="btnNext" class="btn btn-primary pull-right" @click="wizardNextStep(2, 'Step2')">
                              <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                            </button>
                          </b-col>
                        </b-row>
                        <form class="validationForm" data-vv-scope="Step2" onsubmit="event.preventDefault(); return false;">
                          <b-row>
                            <b-col lg="12">
                              <b-card>
                                <div class="my-1" style="float:left;" v-if="!activeReport.applicableCaptiveLender"><strong>Tracked Lender</strong></div>
                                <div class="dx-fieldset my-0" style="float:left; width:50%;">
                                  <div class="dx-field" v-if="!activeReport.applicableCaptiveLender">
                                    <dx-lookup id="selTrackedLender" :items="availableLenders" style="z-index:99999"
                                               :value.sync="activeReport.trackedLender"
                                               :show-popup-title="true"
                                               display-expr="Name"
                                               placeholder="Select Tracked Lender"
                                               title="Select Tracked Lender"
                                               v-validate="{required: true}"
                                               name="Tracked Lender"
                                               :isValid="HasError('Step2.Tracked Lender')"
                                               :validationError="GetError('Step2.Tracked Lender')" />
                                  </div>
                                </div>
                                <div class="my-2" style="float:left;">
                                  <span v-if="!activeReport.applicableCaptiveLender">or </span><span>Track Captive Lenders: </span>
                                  <c-switch id="trackCaptLendSw" v-model="activeReport.applicableCaptiveLender" @change="clickApplicableCaptiveLender($event)" type="text" variant="primary" on="On"
                                            off="Off" :pill="true" />
                                </div>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col lg="7">
                              <b-card>
                                <div slot="header">
                                  <strong>Compared Lenders</strong>
                                  <b-form-input id="inpCompLenderSearch" v-model="lenderSearch" class="ml-4 w-50" style="display:inline" placeholder="Type to Search" />
                                </div>
                                <b-row style="height: 425px; overflow: auto">
                                  <b-col lg="12">
                                    <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                                      <thead class="thead-light">
                                        <tr>
                                          <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">Lender Name</th>
                                          <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;">
                                            <button @click="selectAllComparedLenders" class="btn btn-primary text-white btn-sm">
                                              <i title="Select/Unselect All Compared Lenders" class="fa fa-check-square"></i> {{
                                            activeReport.comparedLenders === undefined || activeReport.comparedLenders.length === 0 ? 'Select All' :
                                            'Unselect All'
                                              }}
                                            </button>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-if="!availableLenders.length" class="b-table-empty-row">
                                          <td colspan="3">
                                            <div role="alert" aria-live="polite">
                                              <div class="text-center my-2">No lenders found.</div>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr v-for="(l, i) in filteredLenders">
                                          <td>
                                            {{l.Name}}
                                          </td>
                                          <td>
                                            <c-switch :id="l.Name" v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </b-col>
                                </b-row>
                              </b-card>
                            </b-col>
                            <b-col lg="5">
                              <b-card>
                                <div slot="header">
                                  <div class="py-2"><strong class="p-1">Selections</strong></div>
                                </div>

                                <b-row style="height: 425px; overflow: auto">
                                  <b-col lg="12">
                                    <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                                      <thead class="thead-light">
                                        <tr>
                                          <th aria-colindex="1">Lender Name</th>
                                          <th aria-colindex="3"></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-if="!selectedComparedLenders.length" class="b-table-empty-row">
                                          <td colspan="3">
                                            <div role="alert" aria-live="polite">
                                              <div class="text-center my-2">No compared lenders selected.</div>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr v-for="(l, i) in selectedComparedLenders">
                                          <td>
                                            {{ l.Name }}
                                          </td>
                                          <td>
                                            <c-switch v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </b-col>
                                </b-row>
                              </b-card>
                            </b-col>
                          </b-row>
                        </form>
                        <div class="my-2">
                          <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step2')" v-bind:key="item.id">
                            {{ `#${item.id}: ${item.msg}`}}
                            <br />
                          </span>
                        </div>
                      </b-tab>
                      <b-tab title="3. Rebate Options">
                        <b-row>
                          <b-col md="12" class="mb-4 p-0">
                            <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                              <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                            </button>
                            <button id="btnNextRebOptions" class="btn btn-primary pull-right" @click="wizardNextStep(3, 'Step3')">
                              <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                            </button>
                          </b-col>
                        </b-row>
                        <b-alert v-if="VehicleSetIsNew" variant="info" dismissed="false" class="w-30" :show="true">
                          Note: These are conditional rebates.
                        </b-alert>
                        <b-alert v-else variant="info" dismissed="false" class="w-30" :show="true">
                          Note: There are no rebates for used vehicles.
                        </b-alert>
                        <form class="validationForm" data-vv-scope="Step3" onsubmit="event.preventDefault(); return false;">
                          <b-row v-bind:class="{'disableRebates': !VehicleSetIsNew}">
                            <b-col md="3">
                              <b-form-group>
                                <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                                  <b-form-checkbox value="4">Loyalty</b-form-checkbox>
                                  <b-form-checkbox value="5">Conquest</b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-form-group>
                            </b-col>
                            <b-col md="3">
                              <b-form-group>
                                <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                                  <b-form-checkbox value="2">College Graduate</b-form-checkbox>
                                  <b-form-checkbox value="1">Military</b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </form>
                        <div class="my-2">
                          <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step3')" v-bind:key="item.id">
                            {{ `#${item.id}: ${item.msg}`}}
                            <br />
                          </span>
                        </div>
                      </b-tab>
                      <b-tab title="4. Report Settings">
                        <b-row>
                          <b-col md="12" class="mb-4 p-0">
                            <b-col md="12" class="mb-4 p-0">
                              <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                                <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                              </button>
                              <button id="btnNextReportSetts" class="btn btn-primary pull-right" @click="wizardNextStep(4, 'Step4')">
                                <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                              </button>
                            </b-col>
                          </b-col>
                        </b-row>
                        <form class="validationForm" data-vv-scope="Step4" onsubmit="event.preventDefault(); return false;">
                          <b-row class="pt-2">
                            <b-row v-if="activeReport.scanMode === 0 || activeReport.scanMode === 2" class="w-100">
                              <label>Lease Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(false)">Unselect All</a>
                              <b-form-group>
                                <b-form-checkbox-group v-model="activeReport.leaseterms"
                                                       :checked="activeReport.leaseterms"
                                                       :plain="false"
                                                       v-validate="{required: true}"
                                                       name="Terms"
                                                       :isValid="HasError('Step4.Terms')">
                                  <b-form-checkbox v-for="t in leaseTerms" :value="t" v-bind:key="t" :id="'l'+t">
                                    {{ t.toString() }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-form-group>
                            </b-row>
                            <b-row v-if="activeReport.scanMode === 1 || activeReport.scanMode === 2" class="w-100">
                              <label>Retail Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(false)">Unselect All</a>
                              <b-form-group>
                                <b-form-checkbox-group v-model="activeReport.retailterms"
                                                       :checked="activeReport.retailterms"
                                                       :plain="false"
                                                       v-validate="{required: true}"
                                                       name="Terms"
                                                       :isValid="HasError('Step4.Terms')">
                                  <b-form-checkbox v-for="t in retailTerms" :value="t" v-bind:key="t" :id="'r'+t">
                                    {{ t.toString() }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-form-group>
                            </b-row>
                            <label>Options:</label>
                            <b-row>
                              <b-form-checkbox class="ml-4" v-model="activeReport.includeOnlyTermsWithTrackedLenderPresent">Only display terms that include Tracked Lender Programs</b-form-checkbox>
                            </b-row>
                          </b-row>
                          <b-row class="pt-2">
                            <b-card>
                              <div slot="header">
                                <strong>Excel Report Settings</strong>
                              </div>
                              <b-row>
                                <b-col>
                                  <label>Credit Score</label>
                                  <b-form-select id="selCredit" v-model="settings.CREDIT_SCORE" :options="selectedCredits" name="Credit Score"
                                                 v-validate="{required: true}" :isValid="HasError('Step4.Credit Score')">
                                  </b-form-select>
                                </b-col>
                                <b-col>
                                  <label>Cash Down</label>
                                  <b-form-select id="selCash" v-model="settings.CASH_DOWN" :options="selectedCashDowns" name="Cash Down"
                                                 v-validate="{required: true}" :isValid="HasError('Step4.Cash Down')">
                                  </b-form-select>
                                </b-col>
                                <b-col>
                                  <label>Scan Mode</label>
                                  <b-form-select id="selScanMode" v-model="settings.SCAN_MODE" :options="settingsscanModeOptions" name="Scan Mode"
                                                 v-validate="{required: true}" :isValid="HasError('Step4.Scan Mode')">
                                  </b-form-select>
                                </b-col>
                                <b-col>
                                  <label>Term</label>
                                  <b-form-select id="selScanMode" v-model="settings.TERM" :options="selectedTerms" name="Filters Term"
                                                 v-validate="{required: true}" :isValid="HasError('Step4.Filters Term')">
                                  </b-form-select>
                                </b-col>
                                <b-col>
                                  <label>Annual Mileage</label>
                                  <b-form-select id="selannualMileage" v-model="settings.ANNUAL_MILEAGE" :options="selectedAnnualMileages" name="Scan Mode"
                                                 v-validate="{required: true}" :isValid="HasError('Step4.Annual Mileage')">
                                  </b-form-select>
                                </b-col>
                              </b-row>
                            </b-card>
                          </b-row>
                        </form>
                        <div class="my-2">
                          <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step4')" v-bind:key="item.id">
                            {{ `#${item.id}: ${item.msg}`}}
                            <br />
                          </span>
                        </div>
                      </b-tab>
                      <b-tab title="5. Report Schedule">
                        <b-row>
                          <b-col md="9" class="mb-4 p-0">
                            <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                              <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                            </button>
                          </b-col>
                          <b-col md="3" class="my-2">
                            <div style="float:right;">
                              Enabled:
                              <c-switch v-model="scheduler.IS_ACTIVE" class="mb-0" type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                        <form class="validationForm" data-vv-scope="Step5" onsubmit="event.preventDefault(); return false;">
                          <template>
                            <div class="popup-property-details">
                              <div class="row">
                                <div class="col-2">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      Type:
                                    </div>
                                    <div>
                                      <dx-select-box :value.sync="scheduler.SelectedType" :items="scheduler.Type" value-expr="value" display-expr="text" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-2">
                                  <div class="buttons-column">
                                    <div v-show="scheduler.SelectedType === 1">
                                      <div class="column-header">
                                        Day of month:
                                      </div>
                                      <div>
                                        <dx-select-box :value.sync="scheduler.newDate" :items="scheduler.AvailableDates" />
                                      </div>
                                    </div>
                                    <div v-show="scheduler.SelectedType === 2">
                                      <div class="column-header">
                                        Day of week:
                                      </div>
                                      <div>
                                        <dx-select-box :value.sync="scheduler.selectedWeekDay" :items="scheduler.WeekDays"
                                                       :text.sync="scheduler.selectedDayName"
                                                       value-expr="value" display-expr="text" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-2">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      Local time:
                                    </div>
                                    <div>
                                      <dx-date-box :value.sync="scheduler.newTime" :display-format="scheduler.use24format? 'HH:mm' : 'shortTime' " type="time" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-3 vcenter">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      &nbsp;
                                    </div>
                                    <div>
                                      <dx-switch width="100" :value.sync="scheduler.use24format" switchedOnText="24 HR" switchedOffText="AM/PM" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-3">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      &nbsp;
                                    </div>
                                    <div style="float: right">
                                      <dx-button text="Add Date" styling-mode="outlined" type="default" :onClick="SchedulerAddDateTimeClick"
                                                 :disabled="!SchedulerCanAdd" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div class="row">
                                <dx-list :data-source="scheduler.WEEKSCHEDULE" noDataText="No days scheduled" :height="150" width="100%"
                                         :onItemClick="SchedulerItemClick"
                                         itemDeleteMode="toggle" :allowItemDeleting="true">
                                  <template #item="{ data }">
                                    <div class="row" style="display: flex !important; padding: 2px">
                                      <div class="col-md-3 vcenter">
                                        <span>{{data.dayName}}</span>
                                      </div>
                                      <div class="col-md-8">
                                        <dx-tag-box :items.sync="data.times" :value.sync="data.times" :displayExpr="SchedulerItemFormat"
                                                    stylingMode="underlined" :search-enabled="false"
                                                    :onValueChanged="SchedulerOnTimeValueChanged" />
                                      </div>
                                    </div>
                                  </template>
                                </dx-list>
                              </div>
                              <div class="row">
                                <dx-list :data-source="scheduler.SCHEDULE" noDataText="No dates scheduled" :height="150" width="100%"
                                         :onItemClick="SchedulerItemClick"
                                         itemDeleteMode="toggle" :allowItemDeleting="true">
                                  <template #item="{ data }">
                                    <div class="row" style="display: flex !important; padding: 2px">
                                      <div class="col-md-3 vcenter">
                                        <span>{{data.date}}{{ SchedulerNth(data.date) }} day of month</span>
                                      </div>
                                      <div class="col-md-8">
                                        <dx-tag-box :items.sync="data.times" :value.sync="data.times"
                                                    :displayExpr="SchedulerItemFormat" stylingMode="underlined" :search-enabled="false"
                                                    :onValueChanged="SchedulerOnTimeValueChanged" />
                                      </div>
                                    </div>
                                  </template>
                                </dx-list>
                              </div>
                              <br />
                              <div class="row">
                                <div class="col-6">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      Add new email recipient:
                                    </div>
                                    <div>
                                      <dx-text-box :value.sync="scheduler.newEmail" mode="email" valueChangeEvent="keyup"
                                                   name="Email" />
                                    </div>
                                  </div>
                                </div>
                                <div class="offset-3 col-3">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      &nbsp;
                                    </div>
                                    <div style="float: right">
                                      <dx-button text="Add Email" styling-mode="outlined" type="default" :onClick="SchedulerAddEmail"
                                                 :disabled="!SchedulerCanAddEmail" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div class="row">
                                <div class="col-12">
                                  <div class="buttons-column">
                                    <div class="column-header">
                                      Emails:
                                    </div>
                                    <div>
                                      <dx-tag-box :items.sync="scheduler.SCHEDULE_EMAIL" :value.sync="scheduler.SCHEDULE_EMAIL" stylingMode="underlined"
                                                  :max-displayed-tags="5"
                                                  :show-multi-tag-only="false"
                                                  placeholder="No recipients added"
                                                  :search-enabled="false"
                                                  v-validate="{required: scheduler.SCHEDULE.length > 0 && scheduler.IS_ACTIVE}"
                                                  :isValid="HasError('Step5.SCHEDULE_EMAIL')"
                                                  :validationError="GetError('Step5.SCHEDULE_EMAIL')"
                                                  name="SCHEDULE_EMAIL" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </form>
                        <div class="my-2">
                          <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step5')" v-bind:key="item.id">
                            {{ `#${item.id}: ${item.msg}`}}
                            <br />
                          </span>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
              </div>
              <b-row class="mx-2">
                <b-col md="12">
                  <button class="btn btn-primary" @click="saveReportTemplate">
                    <i class="fa fa-save"></i> <strong class="text-white">Save</strong>
                  </button>
                  <button class="btn btn-danger text-white" @click="deleteReportTemplate">
                    <i title="Delete" class="fa fa-trash-o fa-lg"></i> <strong>Delete</strong>
                  </button>
                  <slot v-if="canRunReport && validateErrors.items.length === 0">
                    <button id="btnRunReportRepSched" class="btn btn-primary pull-right" @click="runReport">
                      <i class="fa fa-dot-circle-o"></i> <strong class="text-white">Run Report</strong>
                    </button>
                  </slot>
                </b-col>
              </b-row>
              <slot v-if="showReportTitle">
                <b-row class="mx-2">
                  <b-col md="3" class="pt-2">
                    <em class="text-primary pull-right">Set local date for testing schedule</em>
                  </b-col>
                  <b-col md="8">
                    <dx-date-box :value.sync="scheduler.localDateTime" :show-clear-button="true" style="width: 300px"
                                 :use-mask-behavior="true" type="datetime" placeholder="01/01/2021, 2:52 PM" />

                  </b-col>
                </b-row>
              </slot>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>   
    <loading :show.sync="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import Store from '@/store'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import { Validator } from 'vee-validate'

import {
  DxTextBox,
  DxSlider,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox,
  DxDateBox,
  DxButton,
  DxList,
  DxTagBox
} from 'devextreme-vue'
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup'
import { confirm } from 'devextreme/ui/dialog'
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem
} from 'devextreme-vue/html-editor'

export default {
  name: 'PVIReports',
  components: {
    loading,
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    cSwitch,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxButton,
    DxList,
    DxTagBox,
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxItem
  },
  created () {    
    let self = this
    self.initLoad = true 
    self.editReportTemplate()
    self.wizardStep = 0
    self.changesSaved = true
    window.addEventListener('keydown', self.HandleTestValues)
  },
  data () {
    let self = this
    let schedulerObj = {
      MGAUGE_SCHEDULER_ID: 0,
      DEALERSHIP_ID: 0,
      SCHEDULE: [],
      WEEKSCHEDULE: [],
      SCHEDULE_HASH: '',
      SCHEDULE_EMAIL: [],
      IS_ACTIVE: false,
      localDateTime: null,
      newDate: 1,
      newTime: new Date(),
      newEmail: '',
      clear: function () {
        this.MGAUGE_SCHEDULER_ID = 0
        this.DEALERSHIP_ID = 0
        this.IS_ACTIVE = false
        this.WEEKSCHEDULE.splice(0)
        this.SCHEDULE.splice(0)
        this.SCHEDULE_HASH = ''
        this.SCHEDULE_EMAIL.splice(0)
        this.newDate = 1
        this.newTime = new Date()
        this.newEmail = ''
      },
      title: '',
      use24format: false,
      SelectedType: 2,
      selectedDayName: 'Sun',
      selectedWeekDay: 1,
      Type: [{ text: 'Day of month', value: 1 }, { text: 'Day of week', value: 2 } ],
      WeekDays: [{ text: 'Sunday', value: 0 }, { text: 'Monday', value: 1 }, { text: 'Tuesday', value: 2 }, { text: 'Wednesday', value: 3 }, { text: 'Thursday', value: 4 }, { text: 'Friday', value: 5 }, { text: 'Saturday', value: 6 }],
      AvailableDates: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
    }
    return {
      mGauge_Max_Scans: 0,
      CurrentmGaugeReports: 0,
      mGaugeSupressScan: false,
      mGauge_Feature_Values: [],
      scheduler: schedulerObj,
      errMsg: '',
      initLoad: true,
      displayingData: false,
      changesSaved: true,
      canRunReport: false,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      isInternalStaff: Store.state.isInternalStaff,
      lenderSearch: '',
      wizardStep: 0,
      wizardStepToChange: 0,
      // wizardBackStepClicked: false,
      vehicleSets: [],
      activeReport: {},
      annualMileageOptions: [       
        { text: '10,000', value: 10000 },        
        { text: '12,000', value: 12000 },
        { text: '15,000', value: 15000 }
      ],
      scanModeOptions: [
        { text: 'Lease', value: 0 },
        { text: 'Retail', value: 1 },
        { text: 'Both', value: 2 }
      ],
      scanTypeOptions: [
        // { text: 'Profit', value: 1 },
        { text: 'Selling Price', value: 0 }
      ],
      blankReport: {
        id: -1,
        title: 'PVI Report',
        vehicleSet: null,
        creditScores: [720],
        cashDowns: [5],
        annualMileages: [12000],
        cashType: 1,
        scanMode: 0,
        scanType: 0,
        sortBy: 3,
        groupBy: 0,
        adjustmentType: 0,
        adjustmentValueType: 0,
        adjustmentValue: 0,
        includeOnlyTermsWithTrackedLenderPresent: false,
        useAverageReport: true,
        generateAveragePVIData: true,
        applicableCaptiveLender: false,
        leaseterms: [36],
        retailterms: [],
        trackedLender: null,
        comparedLenders: [],
        rebateOptions: [],
        useTargetAcquisition: false
      },
      creditScores: [640, 660, 680, 700, 720],
      cashOptions: [0, 2.5, 5, 7.5, 10],
      retailTerms: [12, 18, 24, 30, 36, 42, 48, 54, 60, 63, 66, 72, 75, 78, 84, 88, 90, 96],
      leaseTerms: [12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 57, 60, 66, 72],
      availableLenders: [],
      settings: {},
      settingsscanModeOptions: [
        { text: 'Lease', value: 0 },
        { text: 'Retail', value: 1 }
      ],
      showReportTitle: false
    }
  },
  methods: {
    SchedulerNth (val) {
      let d = parseInt(val + '')
      if (d > 3 && d < 21) {
        return 'th'
      }
      switch (d % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    },

    SchedulerOnTimeValueChanged (e) {
      let self = this
      let k = -1
      for (let i = 0; i < self.scheduler.SCHEDULE.length; i++) {
        if (self.scheduler.SCHEDULE[i].times.length === 0) {
          k = i
          break
        }
      }
      if (k !== -1) {
        self.scheduler.SCHEDULE.splice(k, 1)
      }
    },
    CreateSchedulerTime (time) {
      let strTime = moment(time).format('HH:mm')
      return strTime
    },
    CreateSchedulerItem (date, time) {
      let self = this
      let obj = {
        'scheduleType': 1,
        'date': date,
        'times': []
      }
      obj.times.push(self.CreateSchedulerTime(time))
      return obj
    },
    CreateWeeklySchedulerItem (day, dayName, time) {
      let self = this
      let obj = {
        'scheduleType': 2,
        'day': day,
        'dayName': dayName,
        'times': []
      }
      obj.times.push(self.CreateSchedulerTime(time))
      return obj
    },
    SchedulerItemFormat (e) {
      let self = this
      let rr = `${moment().format('YYYY-MM-DD')} ${e}`
      if (self.scheduler.use24format) {
        return moment(rr, 'YYYY-MM-DD HH:mm').format('HH:mm')
      } else {
        return moment(rr, 'YYYY-MM-DD HH:mm').format('h:mm A')
      }
    },
    SchedulerItemClick (e, typeid) {
      let self = this
      if (self.scheduler.SelectedType === 2) {
        self.scheduler.selectedWeekDay = e.itemData.day
      } else {
        self.scheduler.newDate = e.itemData.date
      }
    },
    SchedulerAddEmail (e) {
      let self = this
      let email = self.scheduler.newEmail
      let target = self.scheduler.SCHEDULE_EMAIL.find(r => r === email)
      if (target === undefined) {
        self.scheduler.SCHEDULE_EMAIL.push(email)
        self.scheduler.newEmail = ''
      }
    },
    SchedulerAddDateTimeClick () {
      let self = this

      if (self.scheduler.SelectedType === 2) {
        let target = self.scheduler.WEEKSCHEDULE.find(r => r.day === self.scheduler.selectedWeekDay)
        if (target === undefined) {
          self.scheduler.WEEKSCHEDULE.push(self.CreateWeeklySchedulerItem(self.scheduler.selectedWeekDay, self.scheduler.selectedDayName, self.scheduler.newTime))
        } else {
          let time = self.CreateSchedulerTime(self.scheduler.newTime)
          let targetTime = target.times.find(r => r === time)
          if (targetTime === undefined) {
            target.times.push(time)
          }
        }
      } else if (self.scheduler.SelectedType === 1) {
        // console.log(`newDate: ${self.scheduler.newDate} newTime: ${self.scheduler.newTime}`)
        let target = self.scheduler.SCHEDULE.find(r => r.date === self.scheduler.newDate)
        if (target === undefined) {
          self.scheduler.SCHEDULE.push(self.CreateSchedulerItem(self.scheduler.newDate, self.scheduler.newTime))
        } else {
          let time = self.CreateSchedulerTime(self.scheduler.newTime)
          let targetTime = target.times.find(r => r === time)
          if (targetTime === undefined) {
            target.times.push(time)
          }
        }
      }
      self.SchedulerSort()
      // console.log(`SelectedValues: ${JSON.stringify(self.scheduler.SCHEDULE)}`)
    },
    SchedulerSort () {
      let self = this
      if (self.scheduler.SCHEDULE !== undefined && self.scheduler.SCHEDULE.length > 0) {
        self.scheduler.SCHEDULE.sort((a, b) => a.date - b.date)
        for (let i = 0; i < self.scheduler.SCHEDULE.length; i++) {
          self.scheduler.SCHEDULE[i].times.sort((a, b) => parseInt(a.replace(':', '')) - parseInt(b.replace(':', '')))
        }
      }

      if (self.scheduler.WEEKSCHEDULE !== undefined && self.scheduler.WEEKSCHEDULE.length > 0) {
        self.scheduler.WEEKSCHEDULE.sort((a, b) => a.day - b.day)
        for (let i = 0; i < self.scheduler.WEEKSCHEDULE.length; i++) {
          self.scheduler.WEEKSCHEDULE[i].times.sort((a, b) => parseInt(a.replace(':', '')) - parseInt(b.replace(':', '')))
        }
      }
    },
    SchedulerLoad (TEMPLATE_ID) {      
      let self = this
      // console.log(`Scheduler LOAD ... TEMPLATE_ID ${TEMPLATE_ID}`)
      let obj = {
        'TEMPLATE_ID': TEMPLATE_ID
      }
      axios.post('/api/mgauge/GetSchedule', obj)
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              // console.log(`SchedulerLoad ${JSON.stringify(response)}`)
              self.scheduler.MGAUGE_SCHEDULER_ID = parseInt(response.data.MGAUGE_SCHEDULER_ID + '')
              self.scheduler.DEALERSHIP_ID = parseInt(response.data.DEALERSHIP_ID + '')
              self.scheduler.IS_ACTIVE = response.data.IS_ACTIVE
              let SCHEDULE_EMAIL_FROMDB = response.data.SCHEDULE_EMAIL
              if (SCHEDULE_EMAIL_FROMDB === undefined || SCHEDULE_EMAIL_FROMDB === null) {
                SCHEDULE_EMAIL_FROMDB = ''
              }
              let arrEmail = SCHEDULE_EMAIL_FROMDB.split(';').filter(x => x.length > 0)
              if (arrEmail instanceof Array) {
                self.scheduler.SCHEDULE_EMAIL.splice(0)
                for (let f = 0; f < arrEmail.length; f++) {
                  self.scheduler.SCHEDULE_EMAIL.push(arrEmail[f])
                }
              }

              console.log(` SCHEDULE ${response.data.SCHEDULE}
                            WEEKSCHEDULE ${response.data.WEEKSCHEDULE}`)

              let arr = JSON.parse(response.data.SCHEDULE)
              if (arr instanceof Array) {
                self.scheduler.SCHEDULE.splice(0)
                for (let f = 0; f < arr.length; f++) {
                  self.scheduler.SCHEDULE.push(arr[f])
                }
                self.SchedulerSort()
              }

              let arrWeek = JSON.parse(response.data.WEEKSCHEDULE)
              if (arrWeek instanceof Array) {
                self.scheduler.WEEKSCHEDULE.splice(0)
                for (let f = 0; f < arrWeek.length; f++) {
                  self.scheduler.WEEKSCHEDULE.push(arrWeek[f])
                }
                self.SchedulerSort()
              }

              // self.scheduler.SCHEDULE_HASH = response.data.SCHEDULE_HASH
              /* console.log(`
                MGAUGE_SCHEDULER_ID ${JSON.stringify(self.scheduler.MGAUGE_SCHEDULER_ID)}
                DEALERSHIP_ID ${JSON.stringify(self.scheduler.DEALERSHIP_ID)}
                SCHEDULE ${JSON.stringify(self.scheduler.SCHEDULE)}
                SCHEDULE_HASH ${JSON.stringify(self.scheduler.SCHEDULE_HASH)}
                SCHEDULE_EMAIL ${JSON.stringify(self.scheduler.SCHEDULE_EMAIL)}
                `) */
            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    customItemCreating (data) {
      if (!data.text || isNaN(data.text)) {
        data.customItem = null
        return
      }

      let amOption = { text: data.text, value: data.text.replace(',', '') }
      this.annualMileageOptions.push(amOption)
      data.customItem = amOption
    },
    selectallLeaseTerms (SelectAll) {
      let self = this
      self.activeReport.leaseterms.splice(0)
      if (SelectAll) {
        self.leaseTerms.forEach(function (i) {
          self.activeReport.leaseterms.push(i)
        })
      }
    },
    selectallRetailTerms (SelectAll) {
      let self = this
      self.activeReport.retailterms.splice(0)
      if (SelectAll) {
        self.retailTerms.forEach(function (i) {
          self.activeReport.retailterms.push(i)
        })
      }
    },
    async createReportTemplate () {
      let self = this
      self.$validator.reset()
      self.initLoad = false
      self.boolLoading = true
      self.activeReport = JSON.parse(JSON.stringify(this.blankReport))
      self.changesSaved = false
      self.$validator.reset()
      self.wizardStep = 0
      self.availableLenders.forEach(function (i) {
        i.Compared = false
        i.Tracked = false
      })
      self.scheduler.clear()
      await self.trueValidateAllSilent(true)
      self.canRunReport = false
      self.boolLoading = false
    },
    updateComparedLender (lender) {
      let self = this
      self.availableLenders.forEach(item => {
        if (item.Name.toLowerCase() === lender.Name.toLowerCase()) {
          item.Compared = lender.Compared
        }
      })
    },
    ScanModeChange () {
      let self = this
      if (self.displayingData === false) {
        if (self.scanMode === 1) {
          self.activeReport.leaseterms = []
          self.settingsscanModeOptions = [{ text: 'Retail', value: 1 }]
        }
        if (self.scanMode === 0) {
          self.activeReport.retailterms = []
          self.settingsscanModeOptions = [{ text: 'Lease', value: 0 }]
        }
        if (self.scanMode === 2) {
          self.settingsscanModeOptions = [{ text: 'Lease', value: 0 }, { text: 'Retail', value: 1 }]
        }
      }
    },
    async editReportTemplate () {
      let self = this
      console.log('self.displayingData 1', self.displayingData)
      if (self.displayingData) return
      self.boolLoading = true      
      self.initLoad = false
      self.wizardStep = 0
      self.displayingData = true
      try {
        let response = await axios.post('/api/pvi/getreporttemplate', null)
        // console.log('response.data ', JSON.stringify(response.data))
        if (response !== null && response !== undefined) {
          if (response.data.lenders !== null && response.data.lenders !== undefined) {
            self.availableLenders = response.data.lenders
          }
          if (response.data.vehiclesets !== null && response.data.vehiclesets !== undefined) {
            self.vehicleSets = response.data.vehiclesets
          }
          if (response.data.settings !== null && response.data.settings !== undefined) {
            self.settings = response.data.settings
          }
        }

        if (response === null || response === undefined || response.data.reporttemplate === null || response.data.reporttemplate === undefined) {
          self.createReportTemplate()
          //self.boolLoading = false
          self.displayingData = false
          return
        }

        //self.boolLoading = false
        let tempObj = JSON.parse(JSON.stringify(self.blankReport))
        self.activeReport = Object.assign(tempObj, response.data.reporttemplate)
        // self.activeReport =  response.data.template
        // self.activeReport.id = reportId

        self.activeReport.useAverageReport = true
        self.activeReport.useTargetAcquisition = false
        self.activeReport.generateAveragePVIData = true

        self.availableLenders.forEach(function (i) {
          i.Compared = false
          if (self.activeReport.trackedLender !== null && self.activeReport.trackedLender.Name === i.Name) {
            self.activeReport.trackedLender = i
          }
        })
        self.activeReport.comparedLenders.forEach(function (i) {
          self.updateComparedLender(i)
        })

        self.changesSaved = true
        self.SchedulerLoad(self.activeReport.id)
        // console.log('activeReport: ' + JSON.stringify(self.activeReport))
        // console.log('response: ' + JSON.stringify(response.data))
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }

      self.canRunReport = await self.trueValidateAllSilent()
      self.displayingData = false
      self.initLoad = false
      self.boolLoading = false
    },
    async saveReportTemplate () {
      let self = this

      const isValid = await self.trueValidateAll()
      self.canRunReport = isValid
      if (isValid) {
        if (self.scheduler.newEmail.length > 0) {
          notify('Please save the email or clear the box', 'warning', 5500)
          return
        }
        self.updateComparedLenders()

        let vehicleSet = self.vehicleSets.find(vs => vs.id === self.activeReport.vehicleSet)
        if (vehicleSet) { self.activeReport.title = `PVI for ${vehicleSet.title}` }

        console.log(JSON.stringify(self.activeReport))
        let obj = {
          activeReport: self.activeReport,
          settings: self.settings,
          scheduler: {
            'MGAUGE_SCHEDULER_ID': self.scheduler.MGAUGE_SCHEDULER_ID,
            'DEALERSHIP_ID': self.scheduler.DEALERSHIP_ID,
            'SCHEDULE': self.scheduler.SCHEDULE,
            'WEEKSCHEDULE': self.scheduler.WEEKSCHEDULE,
            'TEMPLATE_ID': self.activeReport.id,
            'SCHEDULE_EMAIL': self.scheduler.SCHEDULE_EMAIL.join(';'),
            'IS_ACTIVE': self.scheduler.IS_ACTIVE,
            'localDateTime': self.scheduler.localDateTime
          }
        }

        axios.post('/api/pvi/savereporttemplate', obj)
          .then(response => {
            self.boolLoading = false
            self.activeReport = response.data
            self.changesSaved = true
            notify('Report has been saved', 'success', 3500)
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.$router.push('/login')
            }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },
    deleteReportTemplate () {
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/deletereporttemplate', this.activeReport)
            .then(response => {
              this.boolLoading = false
              notify('Report has been deleted', 'success', 3500)
              this.editReportTemplate()
              this.initLoad = true
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
    },
    trueValidateAllSilent (resetNeeded) {
      let self = this
      if (resetNeeded === undefined || resetNeeded === null) {
        resetNeeded = true
      }
      let validations = []
      validations.push(self.$validator.validate('Step1.*', undefined, { silent: true }))
      validations.push(self.$validator.validate('Step2.*', undefined, { silent: true }))
      validations.push(self.$validator.validate('Step3.*', undefined, { silent: true }))
      validations.push(self.$validator.validate('Step4.*', undefined, { silent: true }))
      validations.push(self.$validator.validate('Step5.*', undefined, { silent: true }))

      return Promise.all(validations).then(results => {
        const retValue = results.every(r => r)

        if (resetNeeded === true) {
          self.$validator.reset('Step1.*')
          self.$validator.reset('Step2.*')
          self.$validator.reset('Step3.*')
          self.$validator.reset('Step4.*')
          self.$validator.reset('Step5.*')
        }
        return retValue
      })
    },
    trueValidateAll () {
      let self = this
      let validations = []
      validations.push(self.$validator.validateAll('Step1'))
      validations.push(self.$validator.validateAll('Step2'))
      validations.push(self.$validator.validateAll('Step3'))
      validations.push(self.$validator.validateAll('Step4'))
      if (self.scheduler.SCHEDULE.length > 0 && self.scheduler.IS_ACTIVE) {
        validations.push(self.$validator.validateAll('Step5'))
      }
      return Promise.all(validations).then(results => results.every(r => r))
    },
    async runReport () {
      let self = this
      const isValid = await self.trueValidateAll()
      if (isValid) {
        self.boolLoading = true
        self.updateComparedLenders()

        if (self.changesSaved === false) {
          self.saveReportTemplate()
        }

        axios.post('/api/mgauge/runreport', this.activeReport)
          .then(response => {
            self.boolLoading = false
            // this.errMsg = 'Report queued successfuly. ID:' + response.data.processId + ' Running:' + new Date().toString()
            // this.dismissibleType = 'success'
            // this.showDismissibleAlert = true
            //self.saveReportTemplate()
            setTimeout(function () {
              notify('Your report has been queued', 'success', 3500)
              self.$router.push('/PVI/ReportHistory')
            }, 1500)
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.$router.push('/login')
            }
            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true

            notify('Error running report', 'error', 3500)
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },
    clickApplicableCaptiveLender (event) {
      this.availableLenders.forEach(function (i) {
        i.Tracked = false
      })
      this.activeReport.trackedLender = null
      this.activeReport.applicableCaptiveLender = event
      this.activeReport.useTargetAcquisition = false
      this.changesSaved = false
    },
    selectAllComparedLenders () {
      if (this.activeReport.comparedLenders !== undefined && this.activeReport.comparedLenders.length) {
        this.availableLenders.forEach(function (i) {
          i.Compared = false
        })
      } else {
        this.availableLenders.forEach(function (i) {
          i.Compared = true
        })
      }
      this.updateComparedLenders()
      this.changesSaved = false
    },
    updateComparedLenders () {
      this.activeReport.comparedLenders = this.selectedComparedLenders
    },

    wizardBackStep () {
      let self = this
      self.wizardStep = self.wizardStep - 1
      // self.wizardBackStepClicked = true
    },

    async wizardTabClick (newTabIndex, prevTabIndex, evt) {
      let self = this

      // if (self.wizardBackStepClicked === true) {
      //  self.wizardBackStepClicked = false
      //  return false
      // }

      if (self.wizardStepToChange !== newTabIndex) {
        evt.preventDefault()
      }
      let validateTab = parseInt(parseInt(prevTabIndex) + 1)
      let validationTarget = 'Step' + validateTab

      self.canRunReport = await self.trueValidateAllSilent(false)

      let isValid = await self.$validator.validateAll(validationTarget)
      if (isValid) {
        self.changesSaved = false
        self.wizardStepToChange = newTabIndex
        self.wizardStep = newTabIndex
      }
      return false
    },
    async wizardNextStep (tabID, validationTarget) {
      // console.log(`tabID ${tabID} validationTarget ${validationTarget}`)
      let self = this
      // console.log(`0 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)
      self.canRunReport = await self.trueValidateAllSilent(false)

      // console.log(`1 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)

      let promise = new Promise(async (resolve, reject) => {
        // console.log(`2 tabID ${tabID} validationTarget ${validationTarget}`)

        const isValid = await self.$validator.validateAll(validationTarget)
        // console.log(`isValid: ${JSON.stringify(isValid)}`)
        if (isValid === true) {
          resolve(isValid)
        } else {
          reject(isValid)
        }
      })

      promise.then(value => {
        // console.log(`5 tabID ${tabID} validationTarget ${validationTarget}`)
        self.changesSaved = false
        self.wizardStep = parseInt(tabID + '')
      }, reason => {
        // console.log(`6 tabID ${tabID} validationTarget ${validationTarget}`)
      })

      // console.log(`4 tabID ${tabID} validationTarget ${validationTarget}`)

      return undefined
    },
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return { message: err }
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    },
    HandleTestValues (e) {
      let self = this
      // console.log(`ctrl: ${e.ctrlKey} shift: ${e.shiftKey} alt: ${e.altKey} key: ${e.key} keyCode: ${e.keyCode}`)
      if (e !== undefined && e !== null) {
        if (e.ctrlKey === true && e.shiftKey === true && e.altKey === true && e.key === 'T') {
          if (self.wizardStep === 0) {
            // zipCode
            self.activeReport.zipCode = '93012'
            // vehicleSet
            if (self.vehicleSets.length > 0) {
              self.activeReport.vehicleSet = self.vehicleSets[0].id
            }
            self.activeReport.creditScores = [720]
            self.activeReport.cashType = 1
            self.activeReport.cashDowns = [5]
            self.activeReport.annualMileages = [12000]
            self.activeReport.scanMode = 0
            self.activeReport.scanType = 0
            self.activeReport.adjustmentType = 0
            self.activeReport.adjustmentValueType = 0
            self.activeReport.adjustmentValue = 5000
          }
        }
        if (e.ctrlKey === true && e.shiftKey === true && e.altKey === true && e.key === 'H') {
          self.showReportTitle = true
        }
      }
    }
  },
  computed: {
    VehicleSetIsNew () {
      let self = this
      if (self.activeReport.vehicleSet === undefined || self.activeReport.vehicleSet === null) { return true }

      let vehicleSet = self.vehicleSets.find(vs => vs.id === self.activeReport.vehicleSet)
      if (vehicleSet === undefined || vehicleSet === null) { return true }

      return vehicleSet.isnew
    },
    SchedulerCanAddEmail () {
      let self = this
      let emailRegex = /\S+@\S+\.\S+/
      if (self.scheduler !== undefined && self.scheduler.newEmail !== undefined && self.scheduler.newEmail !== null && self.scheduler.newEmail.length > 0 && emailRegex.test(self.scheduler.newEmail)) {
        return true
      }
      return false
    },
    SchedulerCanAdd () {
      let self = this
      if (self.scheduler !== undefined && self.scheduler.newTime !== undefined && self.scheduler.newDate !== undefined && self.scheduler.newTime !== null && self.scheduler.newDate !== null) {
        return true
      }
      return false
    },
    lenderCalcType () {
      if (this.activeReport.applicableCaptiveLender === true) {
        return this.activeReport.scanMode === 0 ? 2 : 3
      }
      if (this.activeReport.scanMode === 1) {
        return 3
      }

      let rtnValue = 0
      let hasMF = false
      let hasIR = false

      // let i = this.activeReport.trackedLender

      if (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null) {
        if (this.activeReport.trackedLender.hasMoneyFactor) {
          hasMF = true
        }
        if (this.activeReport.trackedLender.hasInterestRate) {
          hasIR = true
        }
      }

      if (hasIR) {
        rtnValue = 3
      }
      if (hasMF) {
        rtnValue = 2
      }
      if (hasMF && hasIR) {
        rtnValue = 1
      }
      if (!hasMF && !hasIR) {
        rtnValue = 2
      }
      if (this.activeReport.trackedLender !== undefined &&
          this.activeReport.trackedLender !== null &&
          this.activeReport.trackedLender.Name === 'Ford Motor Credit') {
        rtnValue = 4
      }

      return rtnValue
    },
    selectedTrackedLender () {
      return this.availableLenders.filter(f => {
        return f.Tracked
      })
    },
    selectedComparedLenders () {
      return this.availableLenders.filter(f => {
        return f.Compared && (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null ? f.Name !== this.activeReport.trackedLender.Name : true)
      })
    },
    filteredLenders () {
      return this.availableLenders.filter(item => {
        return item.Name.toLowerCase().indexOf(this.lenderSearch.toLowerCase()) > -1
      })
    },
    selectedCredits () {
      let self = this
      if (self.activeReport !== undefined && self.activeReport.creditScores !== undefined && self.activeReport.creditScores !== null) {
        var c = self.activeReport.creditScores.sort()
        // ---if Rusty says pick the first element automatically---
        // if (self.settings.CREDIT_SCORE === undefined || self.settings.CREDIT_SCORE === null) {
        //  self.settings.CREDIT_SCORE = c[0]
        // }
        return c
      }
      return []
    },
    selectedCashDowns () {
      let self = this
      if (self.activeReport !== undefined && self.activeReport.cashDowns !== undefined && self.activeReport.cashDowns !== null) {
        return self.activeReport.cashDowns.sort((a, b) => a - b)
      }
      return []
    },
    selectedTerms () {
      let self = this
      if (self.activeReport !== undefined) {
        let combined = null
        if (self.activeReport.leaseterms !== undefined && self.activeReport.retailterms !== undefined) {
          combined = self.activeReport.leaseterms.concat(self.activeReport.retailterms)
        } else if (self.activeReport.leaseterms !== undefined && self.activeReport.retailterms === undefined) {
          combined = self.activeReport.leaseterms
        } else if (self.activeReport.leaseterms === undefined && self.activeReport.retailterms !== undefined) {
          combined = self.activeReport.retailterms
        }
        if (combined !== null) {
          var terms = combined.filter((item, pos) => combined.indexOf(item) === pos)
          return terms.sort()
        }
      }
      return []
    },
    selectedAnnualMileages () {
      let self = this
      if (self.activeReport !== undefined && self.activeReport.annualMileages !== undefined && self.activeReport.annualMileages !== null) {
        return self.activeReport.annualMileages.sort((a, b) => a - b)
      }
      return []
    }
  },
  watch: {
    'scheduler.use24format': function (val, oldVal) {
      // console.log(`use24format val: ${val} oldVal: ${oldVal}`)
      let self = this
      self.SchedulerSort()
    },
    'activeReport.creditScores': function (val, oldVal) {
      let self = this
      if (self.activeReport !== undefined && self.activeReport.creditScores !== undefined && self.activeReport.creditScores !== null &&
        self.settings.CREDIT_SCORE !== undefined && self.settings.CREDIT_SCORE !== null) {
        if (self.activeReport.creditScores.find((c) => c === self.settings.CREDIT_SCORE) === undefined) {
          self.settings.CREDIT_SCORE = null
        }
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('keydown', self.HandleTestValues)
  },
  beforeRouteLeave (to, from, next) {
    // console.log(`${from} -> ${to}`)
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style>

  .disabledTab {
    pointer-events: none;
  }

  .dx-overlay-content {
    min-width: initial !important;
  }

  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .dx-widget .dx-slider-handle {
    background-color: #34b9a7;
  }

  .dx-slider-bar {
    background: #4bc300;
  }

  .centerDiv {
    margin-left: auto;
    margin-right: auto;
  }

  .vcenter {
    margin-top: auto;
    margin-bottom: auto;
  }

  .disableTA {
    pointer-events: none;
    opacity: 0.2;
  }

  .disableRebates {
    pointer-events: none;
    opacity: 0.2;
  }

  .numbercenter {
    text-align: center;
  }
  .dx-htmleditor-content img {
    vertical-align: middle;
    padding-right: 10px;
}

.dx-htmleditor-content table {
    width: 50%;
}

</style>



// WEBPACK FOOTER //
// src/views/PVIReports.vue